module.exports = __webpack_public_path__ + "img/shymkent2.b6a3dd73.jpeg";